var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconBlank(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.67 18.33H3.33a.83.83 0 0 1-.83-.83v-15a.83.83 0 0 1 .83-.83h13.34a.83.83 0 0 1 .83.83v15a.83.83 0 0 1-.83.83Zm-.84-1.66V3.33H4.17v13.34h11.66ZM6.67 5.83h6.66V7.5H6.67V5.83Zm0 3.34h6.66v1.66H6.67V9.17Zm0 3.33h4.16v1.67H6.67V12.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBlank);
export default ForwardRef;